import { ReportConfig } from "../definitions";

const branchExecutiveSummary: ReportConfig = {
  id: "branch-executive-summary",
  name: "Branch Executive Summary",
  options: [
    { name: "startDate", label: "Start Date", dataType: "date", defaultValue: "$YEAR-01-01" },
    { name: "endDate", label: "End Date", dataType: "date", defaultValue: "$YEAR-$MONTH-$DAY" },
    {
      name: "branch",
      label: "Branch",
      dataType: "multi-select-dynamic",
      defaultValueOther: [1, 2, 3, 4, 105, 107, 108, 109],
      optionsDataSource: {
        sql: `
        --SELECT 0 as [ID], 'Select branch' as [Type] UNION
        SELECT ID, [Type]
        FROM [dbo].[BranchType]
        WHERE (IsDeleted IS NULL OR IsDeleted = 0) AND ID IN (1, 2, 3, 4, 105, 107, 108, 109, 110, 100) `,
        returnType: "options",
      },
    },
  ],
  layout: [
    {
      dynamicItemsBy: "branch",
      dynamicItemsEmptyMessage: "Select a branch to start",
      items: [
        {
          id: "data-table",
          title: "",
          widgetType: "table",
          columns: [
            { name: "Carrier", type: "string" },
            { name: "# Apps", type: "number", summary: "sum" },
            { name: "YTD Written", type: "currency", align: "right", summary: "sum" },
            { name: "# Apps", type: "number", summary: "sum" },
            { name: "YTD Paid", type: "currency", align: "right", summary: "sum" },
            { name: "Last YTD Paid", type: "currency", align: "right", summary: "sum" },
            { name: "% Diff", type: "percent", align: "right", summary: "percent" },
          ],
          dataSource: {
            sql: `


IF @branch IS NULL OR @branch = ''
BEGIN
  PRINT 'You must select a branch'
  RETURN
END
ELSE
BEGIN

-- TODO: calc lastStartDate and lastEndDate from start/EndDates
declare @lastStartDate DATETIME;
set @lastStartDate = DATEADD(year, -1, @startDate);
declare @lastEndDate DATETIME;
set @lastEndDate = DATEADD(year, -1, @endDate);

declare @projectionMultiplier float = 365.0 / datepart(dayofyear, getdate());

WITH YTDApplications AS (
  SELECT
      [a].[CarrierID],
      COUNT(*) AS ApplicationsWritten,
      SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumWritten
    FROM [awu].[Application] [a]
      LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
      LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
      LEFT JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
    WHERE a.BranchTypeID = @branch
      AND (@_branch = 0 OR a.BranchTypeID = @_branch)
      AND [a].[EntryDate] BETWEEN @startDate and @endDate
      AND st.[ScenarioTypeCode] = 'F'
      AND aa.CommissionLevel = 1
    GROUP BY [a].[CarrierID]
),
YTDPaidApplications AS (
  SELECT
    [a].[CarrierID],
    COUNT(*) AS ApplicationsPaid,
    SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumPaid
  FROM [awu].[Application] [a]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    LEFT JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
  WHERE a.BranchTypeID = @branch
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)
    AND [a].[PaidOrClosedDate] BETWEEN @startDate and @endDate
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND aa.CommissionLevel = 1
  GROUP BY [a].[CarrierID]
),
LastYearPaidApplications AS (
  SELECT
      [a].[CarrierID],
      COUNT(*) AS ApplicationsWritten,
      SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumPaidLastYear
    FROM [awu].[Application] [a]
      LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
      LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
      LEFT JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
    WHERE a.BranchTypeID = @branch
      AND (@_branch = 0 OR a.BranchTypeID = @_branch)
      AND [a].[PaidOrClosedDate] BETWEEN @lastStartDate and @lastEndDate
      AND st.[ScenarioTypeCode] = 'F'
      AND st.[ApplicationStatusCode] in ('2', '3', 'P')
      AND aa.CommissionLevel = 1
    GROUP BY [a].[CarrierID]
)

SELECT
    [ct].[Type] AS CarrierName,
    ISNULL([ytd].[ApplicationsWritten], 0) AS ApplicationsWrittenYTD,
    ISNULL([ytd].[TotalPremiumWritten], 0) AS TotalPremiumWrittenYTD,
    ISNULL([ytdp].[ApplicationsPaid], 0) AS ApplicationsPaidYTD,
    ISNULL([ytdp].[TotalPremiumPaid], 0) AS TotalPremiumPaidYTD,
    ISNULL([lyp].[TotalPremiumPaidLastYear], 0) AS TotalPremiumPaidLastYearYTD,
    CASE
        WHEN ISNULL([lyp].[TotalPremiumPaidLastYear], 0) = 0 THEN NULL
        ELSE ((ISNULL([ytdp].[TotalPremiumPaid], 0) - ISNULL([lyp].[TotalPremiumPaidLastYear], 0)) / ISNULL([lyp].[TotalPremiumPaidLastYear], 0))
    END AS PercentageDifference,
    0 as [Section]
FROM [dbo].[CarrierType] [ct]
  LEFT JOIN YTDApplications [ytd] ON [ct].[ID] = [ytd].[CarrierID]
  LEFT JOIN YTDPaidApplications [ytdp] ON [ct].[ID] = [ytdp].[CarrierID]
  LEFT JOIN LastYearPaidApplications [lyp] ON [ct].[ID] = [lyp].[CarrierID]
WHERE [ct].[IsDeleted] = 0
    AND ([ytd].[CarrierID] IS NOT NULL OR [ytdp].[CarrierID] IS NOT NULL OR [lyp].[CarrierID] IS NOT NULL)
    AND [ct].[IsDeleted] = 0

UNION

SELECT
    'Projection',
    FLOOR(@projectionMultiplier * SUM(ISNULL([ytd].[ApplicationsWritten], 0))) AS ApplicationsWrittenYTD,
    @projectionMultiplier * SUM(ISNULL([ytd].[TotalPremiumWritten], 0)) AS TotalPremiumWrittenYTD,
    FLOOR(@projectionMultiplier * SUM(ISNULL([ytdp].[ApplicationsPaid], 0))) AS ApplicationsPaidYTD,
    @projectionMultiplier * SUM(ISNULL([ytdp].[TotalPremiumPaid], 0)) AS TotalPremiumPaidYTD,
    @projectionMultiplier * SUM(ISNULL([lyp].[TotalPremiumPaidLastYear], 0)) AS TotalPremiumPaidLastYearYTD,
    @projectionMultiplier * CASE
        WHEN SUM(ISNULL([lyp].[TotalPremiumPaidLastYear], 0)) = 0 THEN NULL
        ELSE ((SUM(ISNULL([ytdp].[TotalPremiumPaid], 0) - ISNULL([lyp].[TotalPremiumPaidLastYear], 0))) / SUM(ISNULL([lyp].[TotalPremiumPaidLastYear], 0)))
    END AS PercentageDifference,
    1 as [Section]
FROM [dbo].[CarrierType] [ct]
  LEFT JOIN YTDApplications [ytd] ON [ct].[ID] = [ytd].[CarrierID]
  LEFT JOIN YTDPaidApplications [ytdp] ON [ct].[ID] = [ytdp].[CarrierID]
  LEFT JOIN LastYearPaidApplications [lyp] ON [ct].[ID] = [lyp].[CarrierID]
WHERE [ct].[IsDeleted] = 0
    AND ([ytd].[CarrierID] IS NOT NULL OR [ytdp].[CarrierID] IS NOT NULL OR [lyp].[CarrierID] IS NOT NULL)
    AND [ct].[IsDeleted] = 0

-- add summary row
UNION

SELECT
    'Total',
    SUM(ISNULL([ytd].[ApplicationsWritten], 0)) AS ApplicationsWrittenYTD,
    SUM(ISNULL([ytd].[TotalPremiumWritten], 0)) AS TotalPremiumWrittenYTD,
    SUM(ISNULL([ytdp].[ApplicationsPaid], 0)) AS ApplicationsPaidYTD,
    SUM(ISNULL([ytdp].[TotalPremiumPaid], 0)) AS TotalPremiumPaidYTD,
    SUM(ISNULL([lyp].[TotalPremiumPaidLastYear], 0)) AS TotalPremiumPaidLastYearYTD,
    CASE
        WHEN SUM(ISNULL([lyp].[TotalPremiumPaidLastYear], 0)) = 0 THEN NULL
        ELSE ((SUM(ISNULL([ytdp].[TotalPremiumPaid], 0) - ISNULL([lyp].[TotalPremiumPaidLastYear], 0))) / SUM(ISNULL([lyp].[TotalPremiumPaidLastYear], 0)))
    END AS PercentageDifference,
    2 as [Section]
FROM [dbo].[CarrierType] [ct]
  LEFT JOIN YTDApplications [ytd] ON [ct].[ID] = [ytd].[CarrierID]
  LEFT JOIN YTDPaidApplications [ytdp] ON [ct].[ID] = [ytdp].[CarrierID]
  LEFT JOIN LastYearPaidApplications [lyp] ON [ct].[ID] = [lyp].[CarrierID]
WHERE [ct].[IsDeleted] = 0
    AND ([ytd].[CarrierID] IS NOT NULL OR [ytdp].[CarrierID] IS NOT NULL OR [lyp].[CarrierID] IS NOT NULL)
    AND [ct].[IsDeleted] = 0

ORDER BY [Section], [ct].[Type]

END
            `,
            returnType: "table",
          },
          options: { summary: false, summaryInData: true, summaryRows: 2 },
        },
      ],
    },
  ],
};

export default branchExecutiveSummary;
